import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './lang' // internationalization

export const eventBus = new Vue() //为兄弟间传值建立起的桥梁

//引入element,全引入
import ElementUI from 'element-ui';

//element按需引入
// import element from './element/index'
import 'element-ui/lib/theme-chalk/index.css';

// 动画animate.css
require('animate.css/animate.min.css');
// 滚动动画wow.js
import {WOW} from 'wowjs'

//引入两个文件
import api from './api/api'
import http from './api/http'
//挂载到VUE实例，以便全局使用
Vue.prototype.api = api;
Vue.prototype.http = http;

import 'echarts/map/js/world.js';
import 'echarts/map/js/china.js';

// import echarts from 'echarts'
// 在vue原型添加
Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // default
  animateClass: 'animated', // default
  offset: 150, // default
  mobile: true, // default
  live: false,

  // live为true时，控制台会提示：MutationObserver is not supported by your browser. & WOW.js cannot detect dom mutations, please call .sync() after loading new content.

  callback: function(box) {
    console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
  }
})

// Vue.prototype.$echarts = echarts;

/*function fontSize() {
  const html = document.documentElement;
  const width = html.clientWidth < 1920 ? 1920 : html.clientWidth;
  width && (html.style.fontSize = 10 * (width / 1920) + 'px')
}

router.beforeEach(((to, from, next) => {
  console.log(to);
  if (to.path === '/index/house' || to.path === '/index/process') {
    window.addEventListener("resize", fontSize, false);
    document.addEventListener("DOMContentLoaded", fontSize, false);
    fontSize();
  } else {
    window.removeEventListener("resize", fontSize);
    document.removeEventListener("DOMContentLoaded", fontSize);
    console.log(document.documentElement.getAttribute("style"));
    document.documentElement.removeAttribute("style");
  }

  next();
}));*/


Vue.config.productionTip = false;

// Vue.use(element);
Vue.use(ElementUI);

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');
